<template>
  <div class="card">
    <div class="card-header">
      <button
        class="btn btn-outline-primary spacer"
        @click="getSector(sector.name)"
        v-for="sector in sectors"
        :key="sector.name"
      >
        {{ sector.code }}
      </button>
    </div>
    <highcharts :options="chartOptions"></highcharts>
  </div>
</template>
  
  <script>
      let agency = JSON.parse(localStorage.getItem("agency"));

export default {
  data() {
    return {
      agency: agency,
      title: "",
      sectors: [
        {
          code: "BHCPF",
          name: "Basic Healthcare Provision Fund",
        },
        {
          code: "SEP",
          name: "State Equity Program",
        },
        {
          code: "VOL",
          name: "Voluntary Contributor",
        },
        {
          code: "SPS",
          name: "State Public Servant",
        },
        {
          code: "SCS",
          name: "State Civil Servant",
        },
      ],
      points: [10, 0, 8, 2, 6, 4, 5, 5],
      chartType: "",
      seriesColor: "#6fcd98",
      colorInputIsSupported: null,
      sector: "Basic Healthcare Provision Fund",
      chartOptions: {},
    };
  },
  mounted() {
    this.getDashboardLGA();
  },
  methods: {
    getDashboardLGA() {
      this.axios
        .get(`/api/v1/auth/AboveandLessAge/${agency.id}/${this.sector}`)
        .then((response) => {
          let data = response.data;
          this.chartOptions = {
            chart: {
              type: "pie",
            },
            title: {
              text: "Enrollee Above & Below 5",
            },

            accessibility: {
              announceNewData: {
                enabled: true,
              },
            },
            xAxis: {
              type: "category",
            },
            plotOptions: {
              series: {
                borderWidth: 0,
                dataLabels: {
                  enabled: true,
                  format: "<b>{point.name}</b>: {point.percentage:.1f} %",
                },
              },
            },

            tooltip: {
              headerFormat:
                '<span style="font-size:11px">{series.name}</span><br>',
              pointFormat:
                '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:.2f}%</b> of total<br/>',
            },

            series: data.gender,
          };
        });
    },

    getSector(sector) {
      this.sector = sector;
      this.getDashboardLGA();
    },
  },
};
</script>
  
  <style></style>
  